module.exports = __webpack_public_path__ + "static/media/icon-paymentTerminal.467db55c.svg";